/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialTagsPaginatedResponse } from '../../models/editorial-tags-paginated-response';
import { GetCompaniesNearMeRequest } from '../../models/get-companies-near-me-request';

export interface GetEditorialTagsPaginated$Params {
  page: number;
  search?: string;
      body: GetCompaniesNearMeRequest
}

export function getEditorialTagsPaginated(http: HttpClient, rootUrl: string, params: GetEditorialTagsPaginated$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorialTagsPaginatedResponse>>> {
  const rb = new RequestBuilder(rootUrl, getEditorialTagsPaginated.PATH, 'post');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EditorialTagsPaginatedResponse>>;
    })
  );
}

getEditorialTagsPaginated.PATH = '/api/editorial/tags/paginated';
